import React from 'react';
import { isEmojiSupported } from 'is-emoji-supported';
import emojiUnicode from 'emoji-unicode';

interface Props {
  unicode: string
  ariaLabel?: string
  className?: string
}

const Emoji = ({
  unicode, ariaLabel, className,
}: Props) => (
  isEmojiSupported(unicode)
    ? (<span className={className} aria-label={ariaLabel || 'emoji'} role="img">{unicode}</span>)
    : (
      <img
        src={`https://twemoji.maxcdn.com/v/13.1.0/72x72/${emojiUnicode(unicode).replace(' ', '-')}.png`}
        alt={emojiUnicode(unicode)}
        style={{ maxHeight: '1.2em', width: 'auto' }}
      />
    ));

Emoji.defaultProps = {
  ariaLabel: undefined,
  className: undefined,
};

export default Emoji;
